const gardeningDetailedRateCard = {
  key: "gardening",
  title: "Gardening Detailed Rate Card",
  note:
    "Indicative gardening pricing. Final charge depends on plant count, terrace or balcony size, soil/material needs, trimming intensity, and visit time.",
  sections: [
    {
      title: "Plant Care",
      items: [
        { name: "Plant repotting", price: "₹149 per pot" },
        { name: "Soil refill / top-up", price: "₹49-₹149 per pot + material" },
        { name: "Basic plant health check", price: "₹199 onwards" },
      ],
    },
    {
      title: "Maintenance",
      items: [
        { name: "Basic garden maintenance", price: "₹499 onwards per visit" },
        { name: "Hedge / plant trimming", price: "₹599 onwards per visit" },
        { name: "Leaf clearing / area cleanup", price: "₹399 onwards" },
      ],
    },
    {
      title: "Consultation",
      items: [
        { name: "Balcony garden setup consultation", price: "₹399 visit" },
      ],
    },
  ],
};

export default gardeningDetailedRateCard;